/**
 * Zone.js configuration flags to optimize performance and reduce bundle size
 * These flags disable unnecessary Zone.js patches for modern browsers
 */

/**
 * Disable patches for APIs that are not commonly used
 * This reduces the polyfill footprint
 */
(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__Zone_disable_on_property = true;
(window as any).__Zone_disable_geolocation = true;
(window as any).__Zone_disable_file = true;
(window as any).__Zone_disable_fs = true;
(window as any).__Zone_disable_mediaQuery = true;
(window as any).__Zone_disable_notification = true;
